<div class="height-100 page">

  <div class="flex-direction-row justify-between align-center">
    @if (fluxosTable.length > 0) {
      <app-form-field style="margin-right: 1%" placeholder="Pesquisar" iconPrefix="search" iconColor="var(--primary)" backgroundColor="transparent" classe="pesquisar"
                      widthFormField="325px" heightFormField="35px" borderColor="var(--primary)" (changeValue)="filtrarFluxos($event)"></app-form-field>
    }
  </div>

  @if (carregando) {
    <app-tabela-skeleton [qntdLinhas]="8"></app-tabela-skeleton>
  }
  @else if (fluxosTable.length > 0) {
    <mat-table [dataSource]="dataSourceFluxo" [trackBy]="trackById" class="full-width-table overflow">
      <ng-container matColumnDef="acoes">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let elemento">
          <app-button-padrao iconSrc="icones/edit" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                             widthIcon="22px" heightIcon="22px" (buttonClick)="abrirModal(false, elemento)"></app-button-padrao>
          <app-button-padrao iconSrc="icones/visualizar" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                             widthIcon="22px" heightIcon="22px" (buttonClick)="abrirModal(true, elemento)"></app-button-padrao>
          <app-button-padrao iconSrc="icones/fluxo" iconSrcExtensao=".svg" width="30px" height="30px" backgroundColor="transparent"
                             widthIcon="22px" heightIcon="22px" (buttonClick)="selecionarFluxo(elemento)"></app-button-padrao>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.id }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef> Status </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> <img src="{{ elemento.ativo ? 'assets/icones/ativo-ui.svg' : 'assets/icones/inativo-ui.svg' }}" alt=""> {{ elemento.ativo ? 'Ativo' : 'Inativo' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="contas">
        <mat-header-cell *matHeaderCellDef> Contas </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.contas.length ?? '--' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="titulo">
        <mat-header-cell *matHeaderCellDef> Título </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> <span class="ellipse" [matTooltip]="elemento.titulo">{{ elemento.titulo }}</span> </mat-cell>
      </ng-container>

      <ng-container matColumnDef="descricao">
        <mat-header-cell *matHeaderCellDef> Descrição </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> <span class="ellipse" [matTooltip]="elemento.descricao">{{ elemento.descricao }}</span> </mat-cell>
      </ng-container>

      <ng-container matColumnDef="qtdEtapas">
        <mat-header-cell *matHeaderCellDef> Qtd Etapas </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.qtdEtapas }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuCriacao">
        <mat-header-cell *matHeaderCellDef> Usu. Criação </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> <span class="ellipse" [matTooltip]="elemento.usuarioCriacao">{{ elemento.usuarioCriacao }}</span> </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataCriacao">
        <mat-header-cell *matHeaderCellDef> Data Criação </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.dataCriacao | date:'dd/MM/yyyy - HH:mm' }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="usuAlteracao">
        <mat-header-cell *matHeaderCellDef> Usu. Alteração </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> <span class="ellipse" [matTooltip]="elemento.usuarioAlteracao">{{ elemento.usuarioAlteracao }}</span> </mat-cell>
      </ng-container>

      <ng-container matColumnDef="dataAlteracao">
        <mat-header-cell *matHeaderCellDef> Data Alteração </mat-header-cell>
        <mat-cell *matCellDef="let elemento"> {{ elemento.dataAlteracao | date:'dd/MM/yyyy - HH:mm' }} </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <app-paginator
      [length]="length"
      [pageSize]="limit"
      [pageIndex]="page"
      [width]="'calc(100% - 16px) !important'"
      (pageChange)="handlePageEvent($event)">
    </app-paginator>
  }
  @else {
    <div class="flex center-center height-100">
      <img style="height: 394px; width: 582px;" src="./assets/imagem-mulher-nao-eh-bug.png" alt="Nenhum fluxo encontrado">
    </div>
  }

  <img src="./assets/botao-add.svg" class="botao-add cursor-pointer" alt="Adicionar fluxo" role="button" tabindex="0" (click)="abrirModal(false)" (keydown.enter)="abrirModal(false)" />
</div>
